import React from 'react';
import './DisclaimerPanel.css';

const DisclaimerPanel = ({ disclaimer, onClose }) => {
  if (!disclaimer) {
    return null;
  }

  return (
    <div className="disclaimer-overlay">
      <div className="disclaimer-panel">
        <button className="close-button" onClick={onClose}>&times;</button>
        <h2>{disclaimer.title}</h2>
        <p>{disclaimer.text}</p>
        <p><em>{disclaimer.not}</em></p>
      </div>
    </div>
  );
};

export default DisclaimerPanel;
